module.exports = __webpack_public_path__ + "img/Superb_sword_10.d8f549c1.png";